export const SYS_PATH_MOTHER = 'SYS_PATH_MOTHER';
export const SYS_PATH_FATHER = 'SYS_PATH_FATHER';
export const SYS_PATH_BROTHER = 'SYS_PATH_BROTHER';
export const SYS_PATH_GRANDFATHER = 'SYS_PATH_GRANDFATHER';
export const SYS_PATH_GRANDMOTHER = 'SYS_PATH_GRANDMOTHER';